// Core Web Vitals monitoring using native PerformanceObserver API
// Thresholds from https://web.dev/vitals/

const thresholds = {
  LCP:  [2500, 4000],
  FID:  [100, 300],
  CLS:  [0.1, 0.25],
  FCP:  [1800, 3000],
  TTFB: [800, 1800],
};

const rate = (name, value) => {
  const [good, poor] = thresholds[name];
  return value <= good ? 'good' : value <= poor ? 'needs-improvement' : 'poor';
};

window.__PERF__ = {};

const observe = (type, callback) => {
  try {
    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) callback(entry);
    });
    po.observe({ type, buffered: true });
  } catch (e) {
    // PerformanceObserver not supported for this type
  }
};

export function reportWebVitals(onReport) {
  const report = (name, value) => {
    const metric = { name, value: Math.round(value * 100) / 100, rating: rate(name, value) };
    window.__PERF__[name] = metric;
    if (onReport) onReport(metric);
  };

  // LCP — Largest Contentful Paint
  observe('largest-contentful-paint', (entry) => {
    report('LCP', entry.startTime);
  });

  // FID — First Input Delay
  observe('first-input', (entry) => {
    report('FID', entry.processingStart - entry.startTime);
  });

  // CLS — Cumulative Layout Shift
  let clsValue = 0;
  observe('layout-shift', (entry) => {
    if (!entry.hadRecentInput) {
      clsValue += entry.value;
      report('CLS', clsValue);
    }
  });

  // FCP — First Contentful Paint
  observe('paint', (entry) => {
    if (entry.name === 'first-contentful-paint') {
      report('FCP', entry.startTime);
    }
  });

  // TTFB — Time to First Byte
  observe('navigation', (entry) => {
    report('TTFB', entry.responseStart);
  });
}
